import React from "react";

const CompanyFooter = () => {
  return (
    <footer className="bg-white text-center py-4 border-t text-gray-500 text-sm">
      © {new Date().getFullYear()} Neuracraft Solutions — AI-Driven Innovation.
    </footer>
  );
};

export default CompanyFooter;
